import React, { useContext, useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';

import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

import { FormProvider, useForm } from 'react-hook-form';

import Image from '../ui/container/Image';
import { InputText } from '../form/InputText';

import logo from '../../assets/images/logo_upnfm.png';
import { block, unblock } from '../../helpers/loading';
import { axiosPublic } from '../../helpers/axios';
import Swal from 'sweetalert2';
import { RouteContext } from '../../context/RouteContext';
import { useNavigate } from 'react-router-dom';
import { AppContext } from '../../context/AppContext';

const schema = yup.object({
	identidad: yup.string().required('Campo requerido'),
	clave: yup.string().required('Campo requerido'),
});

const fields = [
	{
		type: 'text',
		name: 'identidad',
		label: 'Identidad',
		placeholder: '0801199000000',
	},
	{
		type: 'password',
		name: 'clave',
		label: 'Clave',
		placeholder: 'Clave',
	},
];

export default function LoginForm(carnet) {
	const methods = useForm({ resolver: yupResolver(schema) });

	const [mostrar, setMostrar] = useState(true);

	const { convo, setConvocatoria } = useContext(RouteContext);
	const { login } = useContext(AppContext);

	const navigate = useNavigate();

	const onSubmit = async (e) => {
		block();
		axiosPublic('auth', { id_convocatoria: convo, identidad: e.identidad, clave: e.clave }, 'POST')
			.then((response) => {
				login(response.data);
				unblock();
				navigate('/auth/dashboard');
			})
			.catch((error) => {
				setMostrar(false);
				Swal.fire({
					title: 'Error',
					text: 'Algo salió mal.',
					icon: 'error',
					backdrop: true,
					allowOutsideClick: false,
					didClose: () => {
						setMostrar(true);
					},
				});
			});
	};

	const handleClose = () => {
		setConvocatoria(0);
	};

	return (
		<Dialog open={mostrar}>
			<form onSubmit={methods.handleSubmit(onSubmit)} noValidate>
				<DialogTitle align="center">Iniciar sesión</DialogTitle>

				<DialogContent>
					<Image>{<img src={logo} alt="logo" />}</Image>
					<FormProvider {...methods}>
						{fields.map((field) => (
							<InputText key={field['name']} {...field} />
						))}
					</FormProvider>
				</DialogContent>

				<DialogActions sx={{ justifyContent: 'space-between' }}>
					<Button onClick={handleClose}>Registrarse</Button>
					<Button type="submit">Iniciar sesión</Button>
				</DialogActions>
			</form>
		</Dialog>
	);
}
